export const isMobile = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    const mobileKeywords = [
        'Android', 'iPhone', 'iPod', 'iPad', 'Windows Phone',
        'BlackBerry', 'PlayBook', 'Mobile', 'IEMobile', 'Opera Mini', 'Opera Mobi',
         'tablet', 'kindle', 'webos', 'phone', 'iemobile',
    ];
    return mobileKeywords.some(keyword => userAgent.toLowerCase().includes(keyword.toLowerCase()));
    // const mobileRegex = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|windows phone|phone|webos|kindle|tablet|ipad air/i;
    // return mobileRegex.test(userAgent);
};